export const SOCIAL_SECURITY_NUMBER = 'SOCIAL_SECURITY_NUMBER';
export const ZIP_CODE = 'ZIP_CODE';
export const IP_ADDRESS_V4 = 'IP_ADDRESS_V4';
export const IP_ADDRESS_V6 = 'IP_ADDRESS_V6';
export const ZIP_CODE_PLUS_4 = 'ZIP_CODE_PLUS_4';
export const TELEPHONE_NUMBER = 'TELEPHONE_NUMBER';
export const EMAIL_ADDRESS = 'EMAIL_ADDRESS';

export default {
  SOCIAL_SECURITY_NUMBER,
  ZIP_CODE,
  ZIP_CODE_PLUS_4,
  IP_ADDRESS_V4,
  IP_ADDRESS_V6,
  TELEPHONE_NUMBER,
  EMAIL_ADDRESS
};
